module.exports = __webpack_public_path__ + "media/application/images/footer/facebook-d993f2d0c26e2680871c83a35c1027c1.svg";